import { isNumericBoardId } from "../utils/boardUtils";

export function createUpdatedSearchParams(
  searchParams,
  { set = [], remove = [] } = {}
) {
  const nextSearchParams = new URLSearchParams(searchParams);

  remove.forEach((param) => {
    nextSearchParams.delete(param);
  });

  set.forEach(({ name, value }) => {
    if (value === undefined || value === null || value === "") {
      nextSearchParams.delete(name);
      return;
    }

    nextSearchParams.set(name, value);
  });

  return nextSearchParams;
}

export function normalizeInvalidateKeys(invalidateKeys = []) {
  return invalidateKeys.map((queryKey) =>
    Array.isArray(queryKey) ? queryKey : [queryKey]
  );
}

export function resolveBoardFromRouteId(routeId, boards = []) {
  if (!routeId) {
    return { id: null, board: null };
  }

  if (isNumericBoardId(routeId)) {
    const board = boards.find((item) => item.board_id === Number(routeId));
    return { id: board?.board_id || null, board: board || null };
  }

  const board = boards.find((item) => item.key === routeId);
  return { id: board?.board_id || null, board: board || null };
}
